import React from 'react'
import '../styles/intro-block.scss'

import CustomSlider from './Carousel'
import WhyUs from './Why-Us'
import Services from './Services'
import Pricing from './Pricing'

const IntroBlock = () => (
    <div className="intro-block">
        <CustomSlider />
        <WhyUs />
        <Services />
        <Pricing />
    </div>
)

export default IntroBlock